module.exports = __webpack_public_path__ + "a3763809ddc6741759e85836df7d5546.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/power_has_a_price-768.webp.png
// module id = 515
// module chunks = 0